import { useField } from "formik"
import React from "react";

interface FormInputProps {
    inputId?: string;
    name: string;
    placeholder?: string;
    type?: string;
    className?: string;
    errorClassname?: string;
    required?: boolean;
    onValueChange?: (value: string) => void;
}

function FormInput({ inputId, name, placeholder, type = "text", className = "col-12", errorClassname = "text-danger mt-1", required = true, onValueChange }: FormInputProps) {
    const [field, meta] = useField(name);
    const [isFocused, setIsFocused] = React.useState(false);
    const isDateInput = type === "date";
    const hasValue = String(field.value ?? "").length > 0;
    const showDatePlaceholder = isDateInput && !isFocused && !hasValue && !!placeholder;

    return (
        <div className={className}>
            <div style={{ position: "relative", width: "100%", minWidth: 0 }}>
                {required && (
                    <span
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: "0.625rem",
                            transform: "translateY(-50%)",
                            fontSize: "1.2rem",
                            color: "#dc3545",
                            fontWeight: "bold",
                            pointerEvents: "none",
                            zIndex: 2
                        }}
                    >
                        *
                    </span>
                )}
                <input
                    {...field}
                    id={inputId}
                    required={required}
                    placeholder={isDateInput ? undefined : placeholder}
                    type={type}
                    className="form-control"
                    style={{
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: 0,
                        boxSizing: "border-box",
                        paddingLeft: required ? "1.75rem" : undefined,
                        WebkitAppearance: isDateInput ? "none" : undefined,
                        appearance: isDateInput ? "none" : undefined
                    }}
                    onFocus={() => setIsFocused(true)}
                    onBlur={(e) => {
                        setIsFocused(false);
                        field.onBlur(e);
                    }}
                    onChange={(e) => {
                        field.onChange(e);
                        onValueChange?.(e.target.value);
                    }}
                />

                {showDatePlaceholder && (
                    <span
                        style={{
                            position: "absolute",
                            top: "50%",
                            left: required ? "1.75rem" : "0.75rem",
                            transform: "translateY(-50%)",
                            color: "#4e555b ",
                            pointerEvents: "none",
                            backgroundColor: "var(--bs-body-bg, #fff)",
                            padding: "0 0.125rem"
                        }}
                    >
                        {placeholder}
                    </span>
                )}
            </div>

            {meta.touched && meta.error && (
                Array.isArray(meta.error)
                    ? meta.error.map((err, i) => (
                        <div key={i} className={`${errorClassname} ms-4`}>
                            {err}
                        </div>
                    ))
                    : (
                        <div className={`${errorClassname} ms-4`}>
                            {meta.error}
                        </div>
                    )
            )}
        </div>
    );
};

export default FormInput;
